export default class Default {
  constructor(container) {
    this.container = container;
  }

  topEdgePosition() {
    return 0;
  }

  mount() {
    return this;
  }
}
